import React, { useCallback } from 'react'
import { Button, Modal, Tooltip } from 'antd'
import { UserSwitchOutlined } from '@ant-design/icons'
import { useSelector } from 'react-redux'
import fetchAPI from 'src/lib/utils/fetch-api'

interface AuthorizeAsUserButtonProps {
  userId: number
  isActive?: boolean | null
  size?: 'small' | 'middle' | 'large'
}

const ADMIN_ROLE_ID = 1

export default function AuthorizeAsUserButton({
  userId,
  isActive,
  size,
}: AuthorizeAsUserButtonProps) {
  const sessionData = useSelector((state: any) => state.session?.sessionData)
  const canAuthorize =
    sessionData?.roles?.includes(ADMIN_ROLE_ID) && Number(sessionData?.user?.id) !== userId
  const isDisabled = isActive !== true

  const authorizeAsUser = useCallback(() => {
    Modal.confirm({
      title: 'Авторизоваться под этим пользователем?',
      content:
        'Текущая сессия администратора будет переключена. Для возврата потребуется снова войти под своей учётной записью.',
      okText: 'Авторизоваться',
      cancelText: 'Отмена',
      onOk: async () => {
        const result = await fetchAPI(
          `/api/session/impersonate/${userId}`,
          { method: 'POST' },
          true,
        )

        if (result.error) {
          Modal.error({
            title: 'Не удалось авторизоваться',
            content: result.error.message,
          })
          return
        }

        window.location.assign(result.data?.start_page || '/')
      },
    })
  }, [userId])

  if (!canAuthorize) {
    return null
  }

  return (
    <Tooltip title={isDisabled ? 'Нельзя авторизоваться под неактивным пользователем' : undefined}>
      <span>
        <Button
          size={size}
          disabled={isDisabled}
          onClick={event => {
            event.stopPropagation()
            authorizeAsUser()
          }}
        >
          <UserSwitchOutlined />
          Авторизоваться
        </Button>
      </span>
    </Tooltip>
  )
}
